import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AtualizaTemplateController } from "../../../../Controllers/Geral/GestaoDeTemplates/GestaoDeTemplatesController";
import { IDocumentosTemplate } from "../../../../Interfaces/Geral/Documentos/DocumentosInterface";

interface IAtivaDesativaTipoParcelaProps {
    disableTooltip?: boolean;
    ID_DOCUMENTO_TEMPLATE: number;
    FL_ATIVO: boolean;
    then: () => void;
    row: IDocumentosTemplate;
}

export default function AtivaDesativaTemplate(
    props: IAtivaDesativaTipoParcelaProps
) {
    function onButtonClick() {
        AtualizaTemplateController({
            ...props.row,
            FL_ATIVO: props.FL_ATIVO ? false : true,
        }).then(props.then);
    }

    return (
        <button
            type="button"
            className={`btn ${
                props.FL_ATIVO ? "btn-outline-info" : "btn-outline-danger"
            } font-weight-bold mr-2`}
            onClick={onButtonClick}
        >
            {!props.FL_ATIVO ? (
                <>
                    <FontAwesomeIcon size="lg" icon={faCheck} /> Ativar
                </>
            ) : (
                <>
                    <FontAwesomeIcon size="lg" icon={faTimes} /> Desativar
                </>
            )}
        </button>
    );
}
